module.exports = __webpack_public_path__ + "img/cs-icons-twitter-filled.0d9f8a8b.svg";